import React from "react";

const IconChart: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="17"
      viewBox="0 0 15 17"
      fill="none"
    >
      <path
        d="M3.04684 15.6506H2.10934C1.92286 15.6506 1.74402 15.5758 1.61216 15.4427C1.4803 15.3096 1.40622 15.129 1.40622 14.9408V10.6819C1.40622 10.4937 1.4803 10.3131 1.61216 10.18C1.74402 10.0469 1.92286 9.97214 2.10934 9.97214H3.04684C3.23332 9.97214 3.41217 10.0469 3.54403 10.18C3.67589 10.3131 3.74997 10.4937 3.74997 10.6819V14.9408C3.74997 15.129 3.67589 15.3096 3.54403 15.4427C3.41217 15.5758 3.23332 15.6506 3.04684 15.6506Z"
        fill="#fff"
      />
      <path
        d="M9.60937 15.6497H8.67187C8.48539 15.6497 8.30655 15.575 8.17469 15.4418C8.04283 15.3087 7.96875 15.1282 7.96875 14.9399V7.8419C7.96875 7.65365 8.04283 7.47311 8.17469 7.33999C8.30655 7.20688 8.48539 7.1321 8.67187 7.1321H9.60937C9.79585 7.1321 9.97469 7.20688 10.1066 7.33999C10.2384 7.47311 10.3125 7.65365 10.3125 7.8419V14.9399C10.3125 15.1282 10.2384 15.3087 10.1066 15.4418C9.97469 15.575 9.79585 15.6497 9.60937 15.6497Z"
        fill="#fff"
      />
      <path
        d="M12.8906 15.6501H11.9531C11.7666 15.6501 11.5878 15.5753 11.4559 15.4422C11.324 15.3091 11.25 15.1285 11.25 14.9403V4.52984C11.25 4.34159 11.324 4.16105 11.4559 4.02793C11.5878 3.89482 11.7666 3.82004 11.9531 3.82004H12.8906C13.0771 3.82004 13.2559 3.89482 13.3878 4.02793C13.5196 4.16105 13.5937 4.34159 13.5937 4.52984V14.9403C13.5937 15.1285 13.5196 15.3091 13.3878 15.4422C13.2559 15.5753 13.0771 15.6501 12.8906 15.6501Z"
        fill="#fff"
      />
      <path
        d="M6.32811 15.6499H5.39061C5.20413 15.6499 5.02528 15.5751 4.89342 15.442C4.76156 15.3089 4.68748 15.1284 4.68748 14.9401V2.16366C4.68748 1.97541 4.76156 1.79487 4.89342 1.66175C5.02528 1.52864 5.20413 1.45386 5.39061 1.45386H6.32811C6.51459 1.45386 6.69343 1.52864 6.82529 1.66175C6.95715 1.79487 7.03123 1.97541 7.03123 2.16366V14.9401C7.03123 15.1284 6.95715 15.3089 6.82529 15.442C6.69343 15.5751 6.51459 15.6499 6.32811 15.6499Z"
        fill="#fff"
      />
    </svg>
  );
};

export default IconChart;
